module.exports = __webpack_public_path__ + "static/media/Meowth_gaussian2.acc34ded.png";